import { $translate } from '@/utils/i18n';
export default {
    searchList: {
        'searchTxt': [
            {
                'name': $translate('lang.E3202103080008', { defaultText: '产品编码' }),
                'value': 'productCode',
                'type': 'input',
                'unfold': true,
                'span': 7
            },
            {
                'name': $translate('lang.E3202103080002', { defaultText: '产品名称' }),
                'value': 'productName',
                'type': 'input',
                'unfold': true,
                'span': 7
            }
        ],
        'isInquire': true
    },
    table: {
        'height': 200,
        'selectBtn': true,
        'leftWidth': 200,
        'isSingleSelect': true,
        'columns': [
            {
                'label': $translate('lang.E3202103080008', { defaultText: '产品编码' }),
                'prop': 'productCode',
                'width': 80
            },
            {
                'label': $translate('lang.E3202103080002', { defaultText: '产品名称' }),
                'prop': 'productName',
                'width': 200
            }
        ],
        'leftOperation': false
    },
    showPage: true,
    page: {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10,
        'pageNo': 1,
        'pageSizes': [10, 20, 30, 50, 100]
    }
};
